import * as React from 'react';
import { INPUT_HEIGHT } from 'shared/constants/layout';
import styled from 'styled-components';

interface TimeInputProps extends Pick<HTMLInputElement, 'step'> {
    placeholder: string;
    error?: boolean;
    onChange: (date: Date | null) => void;
    value: Date | null;
}

export default function TimeInput({ onChange, value, ...rest }: TimeInputProps) {
    const handleChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
        const parts = e.target.value.split(':');
        const now = new Date();
        const date = new Date(now.getFullYear(), now.getMonth(), now.getDate(), Number(parts[0]), Number(parts[1]));

        if (!isNaN(date.getTime())) {
            onChange(date);
        }
    };

    const valueString = () => {
        if (!value) {
            return '';
        }

        const hours = value.getHours();
        const minutes = value.getMinutes();

        return `${ hours.toString().padStart(2, '0') }:${ minutes.toString().padStart(2, '0') }`;
    };

    return (
        <Root type="time"
            onChange={ handleChange }
            value={ valueString() }
            { ...rest } />
    );
}

const Root = styled.input<{ placeholder?: string, error?: boolean, value?: string }>`
    height: ${ INPUT_HEIGHT }px;
    border: 1px solid ${ ({ theme }) => theme.semanticColor.next.inputBorder };
    border-radius: ${ ({ theme }) => theme.borderRadius };
    min-width: 100px;
    font-family: regular;
    padding: 0 12px;
    background: #fff;

    ${ ({ error, placeholder, theme, value }) => placeholder && !value && `
        :before {
            content: "${ placeholder }";
            color: #9d9d9d;
            position: absolute;
            background: #fff;
            width: 60px;
            ${ error && `color: ${ theme.semanticColor.next.error.main };` }
        }

        :focus:before {
            width: 0;
            content: '';
        }
    ` }

    ${ ({ error, theme }) => error && `
        border-color: ${ theme.semanticColor.next.error.main };
    ` }
`;
